export const rootSx = Object.freeze({
  overflow: 'hidden',
  minHeight: 0,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const editorContainerSx = Object.freeze({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  overflow: 'hidden',
  backgroundColor: 'grey.200',
});
